import WebmVideo from 'src/shared/components/ui/video/webm-video'

interface AuthSideContentVidProps {
  src: string
  fallbackSrc?: string
  title?: string
}

export default function AuthSideContentVid({
  src,
  fallbackSrc,
  title = 'Where home happens.',
}: AuthSideContentVidProps) {
  return (
    <div className="relative flex flex-1">
      <WebmVideo
        src={src}
        fallbackSrc={fallbackSrc}
        className="size-full object-cover"
        containerClassName="absolute inset-0"
        loop={true}
        autoPlay={true}
        muted={true}
      />
      <p className="absolute inset-x-0 bottom-0 px-[54px] pb-[54px] text-[36px] font-medium leading-[1.3] tracking-[-0.84px] text-white lg:pb-[78px] lg:text-[42px]">
        {title}
      </p>
    </div>
  )
}
